import { render, staticRenderFns } from "./PrivacyPolicePage.vue?vue&type=template&id=58a72bc3"
import script from "./PrivacyPolicePage.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicePage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicePage.vue?vue&type=style&index=0&id=58a72bc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports